import React from "react";
import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import classes from "@Front/Components/DesignSystem/ShareFolderModal/classes.module.scss";
import { COMMON_UI_I18N } from "@Front/Components/DesignSystem/helpers/commonUiI18n";

type FolderMsg = typeof COMMON_UI_I18N.folderMessages;

type Props = {
	msg: FolderMsg;
	emailInput: string;
	onEmailChange: (v: string) => void;
	saving: boolean;
	error: string | null;
};

export function NotaryMissingContactEmailModalBody(props: Props): React.JSX.Element {
	const { msg, emailInput, onEmailChange, saving, error } = props;
	const emailHasError = Boolean(error);
	return (
		<>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.COLOR_NEUTRAL_700}>
				{msg.notaryMissingContactEmailModalBody}
			</Typography>
			<Typography typo={ETypo.TEXT_SM_SEMIBOLD} color={ETypoColor.COLOR_NEUTRAL_700}>
				{msg.confrerePreferredEmailLabel}
			</Typography>
			<input
				id="notary-missing-contact-email-input"
				className={classes["input"]}
				type="email"
				autoComplete="email"
				placeholder={msg.notaryMissingContactEmailModalPlaceholder}
				value={emailInput}
				onChange={(e) => {
					onEmailChange(e.target.value);
				}}
				disabled={saving}
				{...(emailHasError
					? { "aria-invalid": true as const, "aria-describedby": "notary-missing-contact-email-error" }
					: {})}
			/>
			{emailHasError ? (
				<span id="notary-missing-contact-email-error" role="alert">
					<Typography typo={ETypo.TEXT_SM_REGULAR} color={ETypoColor.COLOR_ERROR_600}>
						{error}
					</Typography>
				</span>
			) : null}
		</>
	);
}
